import Vue from 'vue'
import VueRouter from 'vue-router'
import Landing from '../views/Landing/Landing.vue'
// import PmLanding from '../views/PMS/PmLanding.vue'
// import CloudPms from '../views/PMS/CloudPms.vue'
// import ServerBasedPms from '../views/PMS/ServerBasedPms.vue'
// import Spe from '../views/PMS/Spe.vue'
// import Mpe from '../views/PMS/Mpe.vue'
// import Smart from '../views/PMS/Smart.vue'
// import RmLanding from '../views/RMS/RmLanding.vue'
// import PosProducts from '../views/RMS/PosProducts.vue'
// import EuroDigiPos from '../views/RMS/EuroDigiPos.vue'
// import StokProducts from '../views/RMS/StokProducts.vue'
// import EuroprotelStok from '../views/RMS/EuroprotelStok.vue'
// import ExtraModulesLanding from '../views/ExtraModules/ExtraModulesLanding.vue'
// import BI from '../views/ExtraModules/BI.vue'
// import Sales from '../views/ExtraModules/Sales.vue'
// import ProtelBlanket from '../views/ExtraModules/ProtelBlanket.vue'
// import AppLanding from '../views/App/AppLanding.vue'
// import Tablet from '../views/App/Tablet.vue'
// import Voyager from '../views/App/Voyager.vue'
// import HK from '../views/App/HK.vue'
// import Messenger from '../views/App/Messenger.vue'
// import BookEngine from '../views/Book/BookEngine.vue'
// import Integrations from '../views/Integrations.vue'
// import Contact from '../views/Contact.vue'





Vue.use(VueRouter)

  const routes = [
    
  {
    path: '/',
    name: 'Landing',
    component: Landing
  },
  // {
  //   path: '/PMS',
  //   name: 'PmLanding',
  //   component: PmLanding
  // },
  {
    path: '/PMS',
    name: 'PmLanding',
    component: () => import('../views/PMS/PmLanding'),
  },
  {
    path: '/PMS/CloudBased',
    name: 'CloudPms',
    component: () => import('../views/PMS/CloudPms'),
  },
  {
    path: '/PMS/ServerBasedPms',
    name: 'ServerBasedPms',
    component: () => import('../views/PMS/ServerBasedPms'),
  },
  {
    path: '/PMS/ServerBasedPms/Spe',
    name: 'Spe',
    component: () => import('../views/PMS/Spe'),
  },
  {
    path: '/PMS/ServerBasedPms/Mpe',
    name: 'Mpe',
    component: () => import('../views/PMS/Mpe'),
  },
  {
    path: '/PMS/ServerBasedPms/Smart',
    name: 'Smart',
    component: () => import('../views/PMS/Smart'),
  },
  {
    path: '/RMS',
    name: 'RmLanding',
    component: () => import('../views/RMS/RmLanding'),
  },
  {
    path: '/RMS/POS',
    name: 'PosProducts',
    component: () => import('../views/RMS/PosProducts'),
  },
  {
    path: '/RMS/POS/EuroDigiPos',
    name: 'EuroDigiPos',
    component: () => import('../views/RMS/EuroDigiPos'),
  },
  {
    path: '/RMS/STOK',
    name: 'StokProducts',
    component: () => import('../views/RMS/StokProducts'),
  },
  {
    path: '/RMS/STOK/europrotelStok',
    name: 'EuroprotelStok',
    component: () => import('../views/RMS/EuroprotelStok'),
  },
  {
    path: '/ExtraModules',
    name: 'ExtraModulesLanding',
    component: () => import('../views/ExtraModules/ExtraModulesLanding'),
  },
  {
    path: '/ExtraModules/BI',
    name: 'BI',
    component: () => import('../views/ExtraModules/BI'),
  },
  {
    path: '/ExtraModules/Sales',
    name: 'Sales',
    component: () => import('../views/ExtraModules/Sales'),
  },
  {
    path: '/ExtraModules/ProtelBlanket',
    name: 'ProtelBlanket',
    component: () => import('../views/ExtraModules/ProtelBlanket'),
  },
  {
    path: '/Applications',
    name: 'AppLanding',
    component: () => import('../views/App/AppLanding'),
  },
  {
    path: '/Applications/Tablet',
    name: 'Tablet',
    component: () => import('../views/App/Tablet.vue'),
  },
  {
    path: '/Applications/Voyager',
    name: 'Voyager',
    component: () => import('../views/App/Voyager.vue'),
  },
  {
    path: '/Applications/HK',
    name: 'HK',
    component: () => import('../views/App/HK'),
  },
  {
    path: '/Applications/Messenger',
    name: 'Messenger',
    component: () => import('../views/App/Messenger'),
  },
  {
    path: '/BookEngine',
    name: 'BookEngine',
    component: () => import('../views/Book/BookEngine'),
  },
  {
    path: '/Integrations',
    name: 'Integrations',
    component: () => import('../views/Integrations'),
  },
  {
    path: '/Contact',
    name: 'Contact',
    component: () => import('../views/Contact'),
  },
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes
})

export default router
